
<div class="questionList">

	@for( question of branch; track question.id ) {

		<div
			class="questionTreeBox"
			[class.disabledForm]="question.bIsDisabled"
			[@foldInOut]
		>

			<div class="questionTreeBoxBorder">
		
				<div class="questionTreeBoxBorderTop"></div>
				<div class="questionTreeBoxBorderBottom"></div>
		
			</div>

			<question-builder 
				[question]="question"
				[siblings]="branch"
				style="flex-grow: 2"
			/>

		</div>

	}

</div>


